import React, {useMemo} from "react";
import {Phone} from "@mui/icons-material";
import {green} from "@mui/material/colors";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const ActiveCallsCard = () => {
    const {responseTime, statuses} = useDashboard();

    const chartData = useMemo(() => {
        return (responseTime || []).map(i => ({
            dateCreated: i?.hour,
            duration: Number(i?.countActiveCalls) || 0,
        }));
    }, [responseTime]);
    const hasActivity = chartData?.some(d => Number(d.duration) > 0);

    return (
        <MiniCard
            icon={Phone}
            color={green[400]}
            title={statuses?.ACTIVE || 0}
            subtitle={"ACTIVE CALLS"}
            data={chartData}
            hideChart={!hasActivity}
        />
    );
};